module.exports = __webpack_public_path__ + "static/media/fund_list_blurred.c73738b6.png";